<template>
  <div class="flex flex-row items-start mb-24">
    <section class="mt-4 w-1/2 border-r-2 border-gray-400 p-4 pl-0">
      <div>
        <label
          for="element-type"
          class="block text-sm leading-5 font-medium text-gray-700 mb-2"
          >Element Type</label
        >
        <v-select
          v-model="element.type"
          :options="elementTypes"
          class="bg-blue-50"
        ></v-select>
      </div>

      <div class="mx-auto mt-6"></div>

      <text-form :element="element" v-if="element.type == 'Text'"></text-form>

      <tick-form :element="element" v-if="element.type == 'Tick'"></tick-form>

      <trigger-form
        :element="element"
        v-if="element.type == 'Narrative trigger'"
      ></trigger-form>

      <background-color-form
        v-if="element.type == 'Background color'"
        :element="element"
      ></background-color-form>

      <background-image-form
        :element="element"
        :repos="repos"
        v-if="element.type == 'Background image/video'"
      ></background-image-form>

      <standalone-image-form
        :element="element"
        :repos="repos"
        v-if="element.type == 'Image/video'"
      ></standalone-image-form>

      <audio-form
        :element="element"
        :repos="repos"
        v-if="element.type == 'Audio'"
      ></audio-form>

      <title-form v-if="element.type == 'Title'" :element="element" mode='show'>
      </title-form>

      <!-- BACKGROUND IMAGE FORM -->
      <button
        v-if="element.type"
        @click="addElement"
        class="mt-4 inline-flex justify-center py-2 px-4 border
          border-transparent pt-2 text-sm leading-5 font-medium rounded-md
          text-white bg-light-blue-500 hover:bg-light-blue-400
          focus:outline-none focus:border-light-blue-600
          focus:shadow-outline-blue active:bg-light-blue-600 transition
          duration-150 ease-in-out"
      >
        <span v-if="mode == 'update'">
          Update element
        </span>
        <span v-else>
          Add element
        </span>
      </button>
    </section>

    <!-- HERE WE SHOWCASE THE CONTENT DESCRIBED ON THE LEFT -->
    <section id="content" class="w-1/2 min-h-screen p-4 relative">
      <div
        class="w-full p-4"
        v-if="element.type == 'Background color'"
        style="min-height:385px"
        :style="{ backgroundColor: element.backgroundColor, display: 'block' }"
      ></div>

      <div class="w-full" v-if="element.type == 'Background image/video'">
        <img :src="element.url" class="w-full" />
      </div>

      <div class="w-full" v-if="element.type == 'Image/video'">
        <img :src="element.url" class="w-full" />
      </div>
      <div class="w-full" v-if="element.type == 'Audio'">
        <audio :src="element.url" class="w-full" />
      </div>

      <div
        class="w-full block p-4 border-gray-400 rounded-md markdown"
        v-if="element.type == 'Text'"
      >
        <div v-html="transformedText" />
      </div>

      <title-element
        v-if="element.type == 'Title'"
        :element="element"
      ></title-element>
    </section>
  </div>
</template>

<script>
// import Component from "../component_location"
import TextForm from "@/components/ElementForm/TextForm.vue";
import TickForm from "@/components/ElementForm/TickForm.vue";
import TitleForm from "@/components/ElementForm/TitleForm.vue";
import TriggerForm from "@/components/ElementForm/TriggerForm.vue";
import TitleElement from "@/components/NarrativeElements/TitleElement.vue";
import ImageForm from "@/components/ElementForm/ImageForm.vue";
import BackgroundColorForm from "@/components/ElementForm/BackgroundColorForm.vue";
import BackgroundImageForm from "@/components/ElementForm/BackgroundImageForm.vue";
import StandaloneImageForm from "@/components/ElementForm/StandaloneImageForm.vue";
import AnimationForm from "@/components/ElementForm/AnimationForm.vue";
import Verte from "verte";
import "verte/dist/verte.css";
import { getData } from "@/views/Datasets/api.js";
import { reportError, openFilePicker } from "@/utils.js";

export default {
  components: {
    Verte,
    TextForm,
    TickForm,
    BackgroundColorForm,
    BackgroundImageForm,
    StandaloneImageForm,
    AnimationForm,
    TitleForm,
    TriggerForm,
    ImageForm,
    TitleElement,
  },

  props: ["element", "repos", "mode"],

  data() {
    return {
      uploading: false,
      imageSelected: false,
      selectedRepo: null,
      selectedDataset: null,
      elementTypes: [
        "Background color",
        "Background image/video",
        "Data chart",
        "Image/video",
        "Audio",
        "Narrative trigger",
        "Text",
        "Tick",
        "Title",
      ],
      numberTicks: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      transitionDuration: [100, 200, 300, 400, 500, 600, 700, 800],
    };
  },

  watch: {
    element: function() {
      if (this.element.url.length > 5) {
        this.imageSelected = true;
      }
    },
    selectedDataset: function(dataset) {
      if (!dataset.isConnected) {
        return; // no data available
      }
      getData(dataset, 0, 100)
        .then((res) => {
          this.$store.commit("setData", res.data.data.select);
        })
        .catch((err) => {
          reportError(err);
        });
    },
  },

  methods: {
    addElement() {
      this.$emit("add-element");
    },

    uploadImage() {
      // UPLOAD NEW IMAGE.
      this.uploading = true;
      const client = openFilePicker();
      var dataType = this.selectedDataset.mimetype.split("/")[0];
      var acceptType = dataType + "/*"; // only accept matching data types...
      var options = {
        accept: [acceptType],
        onUploadDone: this.filesUploaded,
        onCancel: (e) => {
          this.uploading = false;
        },
        maxFiles: 100,
        transformations: { crop: false, circle: false, rotate: false },
      };
      client.picker(options).open();
    },

    filesUploaded(fileInfo) {
      var filesUploaded = fileInfo.filesUploaded;
      // Remove the originalFile embedded document business — redundant information.
      filesUploaded.forEach((file) => {
        delete file.originalFile;
      });
      this.$samsa
        .addFiles(this.selectedDataset.Oid, filesUploaded, false)
        .then((res) => {
          this.$store.commit("setDataset", res.data);
          this.$emit("uploaded");
        })
        .catch((err) => {
          reportError(err);
        });
    },

    selectImage(img) {
      this.element.url = img.url;
      this.imageSelected = true;
    },

    getData() {
      var query = 0;
    },
  },

  computed: {
    data() {
      return this.$store.state.data;
    },

    transformedText() {
      return this.$markdown.render(this.element.text);
    },

    availableDatasets() {
      if (this.selectedRepo) {
        return this.selectedRepo.datasets;
      } else {
        return [];
      }
    },
  },

  mounted() {},
};
</script>

<style></style>
